import React from 'react';
import { IQuestion } from '../../types';
import DropdownQuestion from './DropdownQuestion';
import RadioQuestion from './RadioQuestion';
import TextQuestion from './TextQuestion';

interface IProps {
  question: IQuestion;
}

const Question = ({ question }: IProps) => {
  switch (question.type) {
    case 'dropdown':
      return <DropdownQuestion question={question} />;
    case 'radio':
      return <RadioQuestion question={question} />;
    case 'text':
      return <TextQuestion question={question} />;
    default:
      throw new Error(
        `Invalid Question type for question with id: ${question.id}`,
      );
  }
};

export default Question;
